import { render, staticRenderFns } from "./regionalRestrictions.vue?vue&type=template&id=3abf1dd0"
import script from "./regionalRestrictions.vue?vue&type=script&lang=js"
export * from "./regionalRestrictions.vue?vue&type=script&lang=js"
import style0 from "./regionalRestrictions.vue?vue&type=style&index=0&id=3abf1dd0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports